import { CREATE_ERROR, DELETE_ERROR, CREATE_FATAL_ERROR, DELETE_FATAL_ERROR } from './mutation-types';

import { fetchOrRefreshToken } from '../misc/actions';

export function createError({ dispatch, state, commit }, error) {
    let errors = [];

    if (error?.response?.status === 422) {
        const fields = error.response.data.error.fields;

        if (fields) {
            fields.forEach((field, fieldIndex) => {
                field.messages.forEach((message, messageIndex) => {
                    errors.push(message);
                });
            });
        } else {
            const message = error.response.data.error.message;

            if (message) {
                errors.push(message);
            }
        }
    } else if (error?.response?.status === 500) {
        errors.push(error.response.data.error.message);
    } else if (error?.response?.status === 403) {
        if (window.greenmotion.authenticated) {
            const refreshErrors = dispatch('fetchOrRefreshToken');

            errors = errors.concat(refreshErrors);
        } else {
            errors.push('restart_session');
        }
    } else if (typeof error === 'string') {
        errors.push(error);
    } else {
        errors.push('An error occurred, please refresh and try again.');
    }

    commit(CREATE_ERROR, errors);
}

export function deleteError({ commit }) {
    commit(DELETE_ERROR);
}

export function createFatalError({ commit }) {
    commit(CREATE_FATAL_ERROR);
}

export function deleteFatalError({ commit }) {
    commit(DELETE_FATAL_ERROR);
}
